import gql from 'graphql-tag';

export const getOnePlot = gql`
  query Plot($id: ID!) {
    data: Plot(id: $id) {
      id,
      name,
      status,
      description,
      suspectsCode,
      evidenceCode1,
      evidenceCode2,
      evidenceCode3,
      evidenceCode4,
      evidenceCode5,
      evidenceCode6,
      evidenceCode7,
      evidenceCode8,
      evidenceCode9,
      evidenceCode10,
      evidenceUnlock1,
      evidenceUnlock2,
      evidenceUnlock3,
      evidenceUnlock4,
      evidenceUnlock5,
      evidenceUnlock6,
      evidenceUnlock7,
      evidenceUnlock8,
      evidenceUnlock9,
      evidenceUnlock10,
      numberOfEvidence,
      dressCode,
      maxActors,
      image{
        url
      }
      createdAt,
      updatedAt,
      discountCode
    }
  }
`;
